import React, {useState} from "react";
import { Box, Paper, Typography  } from '@mui/material';
import "../../../css/report.css"
import SymptomItem from "./symptomItem";
import StoryBox from "./symptom story/storyBox";

function SymptomBox(props){
const[modalHasRun, setModalHasRun] = useState(false)//whether exta symptom modal has been used.
// eslint-disable-next-line no-unused-vars
const [indexReturning, setIndexReturning] = useState(1000) //picks up index of symptom item with modal just closed therfore triggering change of state to force re-render of StoryBox.

const symptomItems=props.formData.symptomList.map((symptom, index)=><SymptomItem symptom={symptom} key={index} index={index} setModalHasRun={setModalHasRun} setIndexReturning={setIndexReturning}/>)

return(
    <Paper sx={{padding:"15px", margin:"15px"}}>
    <Typography variant="subtext">
    You have indicated that the patient has the following symptoms.  You may want to provide additional information on some of these using the "Add Info" Buttons next to each symptom. Click "Finished adding symptom info" to edit then save your clinical history
    </Typography>
   <p><Typography variant="subtext">  </Typography></p> 
    
    <Box>
      {symptomItems}
    </Box>
   
    <StoryBox modalHasRun={modalHasRun} melanomaSevenPoint={props.melanomaSevenPoint} idaValues={props.idaValues}/> 
    
    </Paper>
)
}

export default SymptomBox